import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import useStateRef from 'react-usestateref';

const AddToCartSuccessModal = (props) => {
    const history = useHistory();

	const handleGoToCart = ()=>{
        history.push("/checkout/cart");
    }
    return (
		<div className="modal fade c-modal-style show" id="addToCartSuccess" tabindex="-1" aria-labelledby="addToCartSuccessLabel" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
					<div className="modal-content share-modal">
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						<div className="modal-body mt-2">
							<div class="container-fluid cart-modal ss-modified-4" data-ss-variation-applied="1">
								<div class="row">
									<div class="col-12 col-lg-12">
										<div class="row align-items-center">
											<div class="col-auto">
												<h5 class="modal-title" id="defaultModalLabel">Added to Cart</h5>
											</div>
											<div class="col-12 col-md-auto order-3 order-lg-2 px-lg-0">
												<button role="button" class="btn-primary" data-bs-dismiss="modal">Continue Shopping</button>
												<button role="button" class="btn-primary" data-bs-dismiss="modal" onClick={handleGoToCart}>Go to Cart</button>
											</div>
											<ul class="col-12 order-2 order-lg-3 cart-added-items list-unstyled">
												<li class="row g-0">
													<div class="col-auto added-item-label">
														<span class="fwb d-block">Item # {props && props.productId?props.productId:""}</span>
														<span class="">Qty: {props && props.quantity ? props.quantity:1}</span>
													</div>

													<div class="col added-item-content">
														<span dangerouslySetInnerHTML={{__html:props && props.productName ? props.productName : ""}}></span>
													</div>
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
			</div>
		</div>
    )
}

export default AddToCartSuccessModal
